import { BackTop, message, Spin } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateUser } from "redux/actions/userActions";
import { apiGetRegistrationInfo } from "services/dashboardService";
import AppSection from "./AppSection/AppSection";
import ContactSection from "./ContactSection/ContactSection";
import Layout from "./Layout";
import MainSlide from "./MainSlide/MainSlide";
import { UpdateAppInfo } from "redux/actions/appActions";
import RegistrationSelectModal from "components/RegistrationSelectModal";
import { getOrganizationFromDomain } from "utils/paymentConfig";

const HomePage = () => {
  const dispatch = useDispatch();
  const [contactData, setContactData] = useState({});
  const [errorField, setErrorField] = useState([]);
  const [isBusy, setIsBusy] = useState(false);
  const [resStatus, setRecStatus] = useState(true);
  const [appInfo, setAppInfo] = useState({
    registration_info: null,
    discount_codes: [],
    group_list: [],
    registrations: [],
  });
  const [curDomain, setCurDomain] = useState("")
  const [modalOpen, setModalOpen] = useState(false);
  const [openRegistrations, setOpenRegistrations] = useState([]);
  const [selectedRegistration, setSelectedRegistration] = useState(null);

  useEffect(() => {
    let tmpDomain = window.location.hostname;
    // Handle development environment
    if (tmpDomain.trim() === "localhost" || tmpDomain.trim() === "192.168.100.81") {
      // You can uncomment the appropriate development domain
      // tmpDomain = "devtuxedocamp.beclutch.club";
      // tmpDomain = "devyaccamp.beclutch.club";
      tmpDomain = "devwarwick.beclutch.club";
    }

    // Validate domain
    const org = getOrganizationFromDomain(tmpDomain);
    console.log('org', org);
    if (!org) {
      console.error(`Invalid domain: ${tmpDomain}`);
      message.error("Invalid domain configuration");
      return;
    }

    setCurDomain(tmpDomain);
    // Clear any existing user data
    localStorage.removeItem("camper_user_info");
    localStorage.removeItem("camper_step");
    localStorage.removeItem("camper_registration_type");
    dispatch(updateUser({ camp_users: [], first_name: "", last_name: "", email: "", cell_phone: "", token: undefined }));
    dispatch(UpdateAppInfo({ appInfo: undefined }));
    getData(tmpDomain);
  }, []);

  const getData = (tmpDomain) => {
    setIsBusy(true);
    apiGetRegistrationInfo(tmpDomain)
      .then((res) => {
        setIsBusy(false);
        if (res.result) {
          dispatch(UpdateAppInfo({ appInfo: res.data }));
          setAppInfo(res.data);
          // Filter open registrations
          const regs = res.data.registrations || [];
          const openRegs = regs.filter(r => r.status === "1");
          setOpenRegistrations(openRegs);
          if (res.data.registration_info?.status === "1") {
            setRecStatus(true);
          } else {
            setRecStatus(false);
          }
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error("Something went wrong");
      });
  };

  // Handler for registration selection from modal
  const handleRegistrationSelect = (registration) => {
    setSelectedRegistration(registration);
    setModalOpen(false);
    // Route to RegisterPage with registration ID
    window.location.href = `/register?id=${registration.ID}`;
  };

  return (
    <Spin spinning={isBusy}>
      <Layout resStatus={resStatus} appInfo={appInfo}>
        <MainSlide
          resStatus={resStatus}
          appInfo={appInfo}
          curDomain={curDomain}
          openRegistrations={openRegistrations}
          onOpenModal={() => setModalOpen(true)}
        />
        <AppSection resStatus={resStatus} appInfo={appInfo} />
        <ContactSection
          contactData={contactData}
          setContactData={setContactData}
          resStatus={resStatus}
          appInfo={appInfo}
          errorField={errorField}
          setErrorField={setErrorField}
        />
        <RegistrationSelectModal
          open={modalOpen}
          registrations={openRegistrations}
          onSelect={handleRegistrationSelect}
          onCancel={() => setModalOpen(false)}
        />
        <BackTop />
      </Layout>
    </Spin>
  );
};

export default HomePage;
